import React, { useState, useEffect } from "react";
import { useNavigate} from "react-router-dom";
import Lottie from "lottie-react";
import successAnimation from "../Assets/success.json";
import "../Style/PaymentSuccess.css"; // Import the CSS file

const PaymentSuccess = () => {
  const navigate = useNavigate();

  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    setTimeout(() => {
      clearInterval(interval);
      navigate("/", { state: { message: "paymentsuccess" } });
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="payment-main-container">
      <div className="payment-popup">
        <h2>Payment Status</h2>

        <div>
          <p className="success-text">✅ Payment Successful!</p>
          <Lottie
            animationData={successAnimation}
            style={{ width: 200, height: 200 }}
          />
          <p className="redirect-message">
            Redirecting in {countdown} seconds...
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
